import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Coins, ArrowRight, Construction, Mail } from 'lucide-react';

/**
 * Rendered in place of the Web3-only routes when REACT_APP_ENABLE_WEB3=false
 * (i.e. on production hosts that don't run blockchain features yet).
 * Keeps the URL alive, sets honest expectations, and routes the visitor toward
 * something useful instead of a dead page.
 */
export default function Web3ComingSoon({ feature = 'This feature' }) {
  return (
    <div className="min-h-[60vh] -mx-4 sm:-mx-6 lg:-mx-8 -mt-8 bg-gradient-to-br from-slate-950 via-slate-900 to-emerald-950 text-white" data-testid="web3-coming-soon">
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 mb-6 shadow-lg">
          <Construction className="h-7 w-7 text-white" />
        </div>
        <Badge className="bg-amber-500/20 text-amber-300 border-amber-500/40 mb-4">$SEED · Web3 · DeFi</Badge>
        <h1 className="text-3xl sm:text-5xl font-black leading-tight">
          {feature} is on the way.
        </h1>
        <p className="mt-6 text-slate-300 text-lg leading-relaxed max-w-xl mx-auto">
          The DowUrk $SEED token, DeFi lending portal, and crypto donation rails are built and tested — they're going live with the mainnet contract launch. We're holding the line until that's audited and ready, on purpose.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/mental-health">
            <Button size="lg" className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold h-12 px-7" data-testid="web3-soon-mw-cta">
              <Coins className="mr-2 h-5 w-5" /> Start with Mental Wealth Month
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          <Link to="/donate">
            <Button size="lg" variant="outline" className="border-slate-600 bg-slate-900/40 hover:bg-slate-800 text-white h-12 px-7" data-testid="web3-soon-donate-cta">
              Donate via card
            </Button>
          </Link>
        </div>
        <Card className="mt-12 bg-slate-900/40 border-slate-800 max-w-xl mx-auto text-left">
          <CardContent className="p-6 flex items-start gap-4">
            <Mail className="h-5 w-5 text-emerald-400 mt-0.5 flex-shrink-0" />
            <div>
              <div className="font-semibold text-white">Be the first to know.</div>
              <p className="text-sm text-slate-400 mt-1">
                Subscribe to the DowUrk newsletter and we'll email you the day $SEED goes live with audited contract addresses and the DeFi onboarding flow.
              </p>
              <Link to="/" className="text-sm text-emerald-400 font-semibold inline-flex items-center gap-1 mt-3 hover:gap-2 transition-all" data-testid="web3-soon-newsletter">
                Subscribe on the home page <ArrowRight className="h-3 w-3" />
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
